import React, { useState, useEffect } from "react";
import "./noticeboard.css";
import PageHeader from "../about/PageHeader";

import Navbar from "../components/navbar";
import Footer from "../components/Footer";

const NoticeBoard = () => {
  const [activeTab, setActiveTab] = useState("Notices");
  const [filters, setFilters] = useState({
    semester: null,
    examType: null,
    monthYear: null,
  });
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;
  const defaultFilters = {
    semester: null,
    examType: null,
    monthYear: null,
  };

  // Fully populated data from your provided list
const allData = {
    Notices: [
      { id: 1, name: "Open House of ESE for Sem – III", semester: "Sem III", category: "ESE", year: "", pdf: "/Notices/Open House of ESE for Sem – III.pdf" },
      { id: 2, name: "Submission of KT Exam Form for Sem – I (Second Half 2025)", semester: "Sem I", category: "KT", year: "SH 2025", pdf: "/Notices/Submission of KT Exam Form for Sem – I (Second Half 2025).pdf" },
      { id: 3, name: "Exam form submission for End Semester Theory Examination (ESE) – Semester III (Autonomous) -SH 2025", semester: "Sem III", category: "ESE", year: "SH 2025", pdf: "/Notices/Exam form submission for End Semester Theory Examination (ESE) – Semester III (Autonomous) -SH 2025.pdf" },
      { id: 4, name: "Submission of KT Exam form Sem – II (Autonomous)", semester: "Sem II", category: "KT", year: "", pdf: "/Notices/Submission of KT Exam form Sem – II (Autonomous).pdf" },
      { id: 5, name: "Collection of Hall Ticket for MCA Sem. III KT (Autonomous) Examination", semester: "Sem III", category: "Hall Ticket", year: "", pdf: "/Notices/Collection of Hall Ticket for MCA Sem. III KT (Autonomous) Examination.pdf" },
      { id: 6, name: "Submission of KT Exam Form of Sem – I, II, III, IV First half 2025", semester: "Sem I-IV", category: "KT", year: "FH 2025", pdf: "/Notices/Submission of KT Exam Form of Sem – I, II, III, IV First half 2025.pdf" },
      { id: 7, name: "Submission of Online Revaluation and Photocopy Form for Second Half 2024", semester: "All", category: "Revaluation", year: "SH 2024", pdf: "/Notices/Submission of Online Revaluation and Photocopy Form for Second Half 2024.pdf" },
      { id: 8, name: "Collection of Hall Ticket of MCA Bridge Course Exam", semester: "Bridge", category: "Hall Ticket", year: "", pdf: "/Notices/Collection of Hall Ticket of MCA Bridge Course Exam.pdf" },
      { id: 9, name: "Submission of Online Revaluation and Photocopy Form for First Half 2024", semester: "All", category: "Revaluation", year: "FH 2024", pdf: "/Notices/Submission of Online Revaluation and Photocopy Form for First Half 2024.pdf" },
      { id: 10, name: "Submission of Exam Form of Bridge Course Exam for 2nd Half 2024", semester: "Bridge", category: "Exam Form", year: "SH 2024", pdf: "/Notices/Submission of Exam Form of Bridge Course Exam for 2nd Half 2024.pdf" },
      { id: 11, name: "Submission of Offline Exam Form for Sem – I to IV KT Exam 2nd Half 2024", semester: "Sem I-IV", category: "KT", year: "SH 2024", pdf: "/Notices/Submission of Offline Exam Form for Sem – I to IV KT Exam 2nd Half 2024.pdf" },
      { id: 12, name: "Collection of Marksheet Sem – IV", semester: "Sem IV", category: "Marksheet", year: "", pdf: "/Notices/Collection of Marksheet Sem – IV.pdf" },
      { id: 13, name: "Collection of Marksheet Sem – I KT and Revaluation", semester: "Sem I", category: "Marksheet", year: "", pdf: "/Notices/Collection of Marksheet Sem – I KT and Revaluation.pdf" },
      { id: 14, name: "Submission of Online Revaluation Form for First Half 2024", semester: "All", category: "Revaluation", year: "FH 2024", pdf: "/Notices/Submission of Online Revaluation Form for First Half 2024.pdf" },
      { id: 15, name: "Collection of Marksheet Second Half 2023", semester: "All", category: "Marksheet", year: "SH 2023", pdf: "/Notices/Collection of Marksheet Second Half 2023.pdf" },
      { id: 16, name: "Sem – IV Internship Project and Research Paper Submission", semester: "Sem IV", category: "Project", year: "", pdf: "/Notices/Sem – IV Internship Project and Research Paper Submission.pdf" },
      { id: 17, name: "Submission of Online Exam Forms of Bridge Course for First Half 2024", semester: "Bridge", category: "Exam Form", year: "FH 2024", pdf: "/Notices/Submission of Online Exam Forms of Bridge Course for First Half 2024.pdf" },
      { id: 18, name: "Collection of Hall Tickets for First Half 2024 (Sem – 3 KT)", semester: "Sem III", category: "Hall Ticket", year: "FH 2024", pdf: "/Notices/Collection of Hall Tickets for First Half 2024 (Sem – 3 KT).pdf" },
      { id: 19, name: "Submission of Online Revaluation & Photocopv forms (S.H.2023)", semester: "All", category: "Revaluation", year: "SH 2023", pdf: "/Notices/Submission of Online Revaluation & Photocopv forms (S.H.2023).pdf" },
      { id: 20, name: "Notice : Collection of Sem – II KT Hall Tickets of Second Half 2022 Exam", semester: "Sem II", category: "Hall Ticket", year: "SH 2022", pdf: "/Notices/Notice : Collection of Sem – II KT Hall Tickets of Second Half 2022 Exam.pdf" },
      { id: 21, name: "Notice : Collection of Sem – I and III Regular and Sem – II KT Marksheet of Second Half 2022 Exam", semester: "Sem I-III", category: "Marksheet", year: "SH 2022", pdf: "/Notices/Notice : Collection of Sem – I and III Regular and Sem – II KT Marksheet of Second Half 2022 Exam.pdf" },
      { id: 22, name: "Notice : Sem – I (Regular) & Sem. II (KT) Hall Ticket Distribution", semester: "Sem I-II", category: "Hall Ticket", year: "", pdf: "/Notices/Notice : Sem – I (Regular) & Sem. II (KT) Hall Ticket Distribution.pdf" },
      { id: 23, name: "Notice – Oral, Practical & Theory Exams Commencement Dates for Sem I (Batch 2022-24)", semester: "Sem I", category: "Exam Dates", year: "2022-24", pdf: "/Notices/Notice – Oral, Practical & Theory Exams Commencement Dates for Sem I (Batch 2022-24).pdf" },
      { id: 24, name: "Notice : Collection of Sem – IV Examination Marksheet and Certificate", semester: "Sem IV", category: "Marksheet", year: "", pdf: "/Notices/Notice : Collection of Sem – IV Examination Marksheet and Certificate.pdf" },
      { id: 25, name: "Notice :  Sem – III Hall Tickets Distribution", semester: "Sem III", category: "Hall Ticket", year: "", pdf: "/Notices/Notice :  Sem – III Hall Tickets Distribution.pdf" },
      { id: 26, name: "Notice : Theory Exam Pattern for SH 2022 Exam", semester: "All", category: "Exam Pattern", year: "SH 2022", pdf: "/Notices/Notice : Theory Exam Pattern for SH 2022 Exam.pdf" },
      { id: 27, name: "Notice -Dates of submission of offline exam forms for SEM II KT Exam", semester: "Sem II", category: "KT", year: "", pdf: "/Notices/Notice -Dates of submission of offline exam forms for SEM II KT Exam.pdf" },
      { id: 28, name: "Notice – Oral, Practical & Theory Exams Commencement Dates for Sem III (Batch 2021-23)", semester: "Sem III", category: "Exam Dates", year: "2021-23", pdf: "/Notices/Notice – Oral, Practical & Theory Exams Commencement Dates for Sem III (Batch 2021-23).pdf" },
      { id: 29, name: "Notice – Return of Marksheet for Correction for Sem – I (SH 2021)", semester: "Sem I", category: "Marksheet", year: "SH 2021", pdf: "/Notices/Notice – Return of Marksheet for Correction for Sem – I (SH 2021).pdf" },
      { id: 30, name: "Notice – Collection of Marksheet for Sem – I (SH 2021)", semester: "Sem I", category: "Marksheet", year: "SH 2021", pdf: "/Notices/Notice – Collection of Marksheet for Sem – I (SH 2021).pdf" },
      { id: 31, name: "Notice – Collection of Marksheet for Sem – III and Sem – V (SH 2021)", semester: "Sem III, V", category: "Marksheet", year: "SH 2021", pdf: "/Notices/Notice – Collection of Marksheet for Sem – III and Sem – V (SH 2021).pdf" },
      { id: 32, name: "Revision in Examination Fee", semester: "General", category: "Fees", year: "", pdf: "/Notices/Revision in Examination Fee.pdf" },
      { id: 33, name: "University of Mumbai – MCA 3 year course to 2 year course Ammendment Notice", semester: "General", category: "General", year: "", pdf: "/Notices/University of Mumbai – MCA 3 year course to 2 year course Ammendment Notice.pdf" },
      { id: 34, name: "CGPI to percentage conversion", semester: "General", category: "General", year: "", pdf: "/Notices/CGPI to percentage conversion.pdf" },
      { id: 35, name: "MCA Manual on CBCGS", semester: "General", category: "Manual", year: "", pdf: "/Notices/MCA Manual on CBCGS.pdf" },
      { id: 36, name: "Manual on grading system", semester: "General", category: "Manual", year: "", pdf: "/Notices/Manual on grading system.pdf" }
    ],
    Toppers: [
      { id: 101, name: "Institute Toppers First Half 2025 MCA Exam (Batch 2023-25)", semester: "All", category: "Toppers", year: "FH 2025", pdf: "/Notices/Institute Toppers First Half 2025 MCA Exam (Batch 2023-25).pdf" },
      { id: 102, name: "Institute Toppers First Half 2025 MCA Exam (Batch 2024-26)", semester: "All", category: "Toppers", year: "FH 2025", pdf: "/Notices/Institute Toppers First Half 2025 MCA Exam (Batch 2024-26).pdf" },
      { id: 103, name: "University and Institute Toppers in 2nd Half 2024 MCA Exam", semester: "All", category: "Toppers", year: "SH 2024", pdf: "/Notices/University and Institute Toppers in 2nd Half 2024 MCA Exam.pdf" },
      { id: 104, name: "Institute Toppers of TIMSCDR in Second Half 2023 MCA Sem. lll Examination", semester: "Sem III", category: "Toppers", year: "SH 2023", pdf: "/Notices/Institute Toppers of TIMSCDR in Second Half 2023 MCA Sem. lll Examination.pdf" },
      { id: 105, name: "University and Institute Toppers of First Half 2023", semester: "All", category: "Toppers", year: "FH 2023", pdf: "/Notices/University and Institute Toppers of First Half 2023.pdf" },
      { id: 106, name: "Sem – I Toppers of Second Half 2022", semester: "Sem I", category: "Toppers", year: "SH 2022", pdf: "/Notices/Sem – I Toppers of Second Half 2022.pdf" },
      { id: 107, name: "University & Institute Topper of TIMSCDR in First half 2022 MCA Examination (MCA 3 Years)", semester: "All", category: "Toppers", year: "FH 2022", pdf: "/Notices/University & Institute Topper of TIMSCDR in First half 2022 MCA Examination (MCA 3 Years).pdf" },
      { id: 108, name: "University & Institute Topper of TIMSCDR in First half 2022 MCA Examination", semester: "All", category: "Toppers", year: "FH 2022", pdf: "/Notices/University & Institute Topper of TIMSCDR in First half 2022 MCA Examination.pdf" },
      { id: 109, name: "University & Institute Topper of TIMSCDR in second half 2021 for  Sem – III and Sem – V MCA Examination", semester: "Sem III, V", category: "Toppers", year: "SH 2021", pdf: "/Notices/University & Institute Topper of TIMSCDR in second half 2021 for  Sem – III and Sem – V MCA Examination.pdf" }
    ],
  };

  const filteredData = allData[activeTab].filter((item) => {
    const matchesSemester = !filters.semester || item.semester === filters.semester;
    const matchesExamType = !filters.examType || item.category === filters.examType;
    const matchesMonthYear = !filters.monthYear || (item.year && item.year.includes(filters.monthYear));
    return matchesSemester && matchesExamType && matchesMonthYear;
  });

  useEffect(() => { setCurrentPage(1); }, [activeTab, filters]);

  // Handle pagination values correctly
  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));
  const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handleQuickFilter = (type, val) => {
    setFilters(prev => ({ ...prev, [type]: prev[type] === val ? null : val }));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilters(defaultFilters);
  };

  const getBadgeClass = (semester) => {
    if (semester.includes("III") || semester.includes("IV")) return "tims-nb-badge tims-nb-badge-green";
    if (semester.includes("I") || semester.includes("II")) return "tims-nb-badge tims-nb-badge-yellow";
    if (semester === "All" || semester === "General") return "tims-nb-badge tims-nb-badge-pink";
    return "tims-nb-badge tims-nb-badge-default";
  };

  // Helper to generate an array of page numbers to render
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
       <Navbar />
      <div className="tims-nb-page-root">
        <PageHeader
          title="Notice Board "
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Result Analysis" },
          ]}
        />
        <div className="tims-nb-container">
          <div className="tims-nb-content-wrapper">
            
            {/* Tabs */}
            <div className="tims-nb-tabs">
              <div
                className="tims-nb-tab-indicator"
                style={{
                  transform:
                    activeTab === "Notices"
                      ? "translateX(0%)"
                      : "translateX(100%)",
                }}
              />
              <button
                className={`tims-nb-tab ${activeTab === "Notices" ? "active" : ""}`}
                onClick={() => handleTabChange("Notices")}
              >
                General Notices
              </button>
              <button
                className={`tims-nb-tab ${activeTab === "Toppers" ? "active" : ""}`}
                onClick={() => handleTabChange("Toppers")}
              >
                Topper Lists
              </button>
            </div>

            {/* Quick Filters */}
            {activeTab === "Notices" && (
              <div className="tims-nb-filters">
                <button 
                  className={`tims-nb-filter-chip ${filters.examType === "KT" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("examType", "KT")}
                >
                  KT Exams
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.examType === "Revaluation" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("examType", "Revaluation")}
                >
                  Revaluation
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.semester === "Sem III" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("semester", "Sem III")}
                >
                  Sem III
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.monthYear === "2025" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("monthYear", "2025")}
                >
                  2025
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.monthYear === "2024" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("monthYear", "2024")}
                >
                  2024
                </button>
              </div>
            )}

            {activeTab === "Toppers" && (
              <div className="tims-nb-filters">
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2025" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2025")}
                >
                  2025
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2024" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2024")}
                >
                  2024
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2023" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2023")}
                >
                  2023
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2022" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2022")}
                >
                  2022
                </button>
              </div>
            )}

            {/* Table */}
            <div className="tims-nb-table-container">
              <table className="tims-nb-table">
                <thead>
                  <tr>
                    <th>Document Name</th>
                    <th>Semester</th>
                    <th>Category</th>
                    <th>Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <div className="tims-nb-doc-cell">
                            <svg className="tims-nb-doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                              <polyline points="14 2 14 8 20 8"></polyline>
                              <line x1="16" y1="13" x2="8" y2="13"></line>
                              <line x1="16" y1="17" x2="8" y2="17"></line>
                              <polyline points="10 9 9 9 8 9"></polyline>
                            </svg>
                            <span className="tims-nb-doc-name">{item.name}</span>
                          </div>
                        </td>
                        <td>
                          <span className={getBadgeClass(item.semester)}>
                            {item.semester}
                          </span>
                        </td>
                        <td className="tims-nb-text-dark">{item.category}</td>
                        <td className="tims-nb-text-dark">{item.year || "-"}</td>
                        <td>
                          <button className="tims-nb-view-btn" onClick={() => window.open(item.pdf)}>
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center", padding: "30px", color: "#64748B" }}>
                        No notices found matching your filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="tims-nb-pagination">
                <button 
                  className="tims-nb-page-nav" 
                  disabled={currentPage === 1} 
                  onClick={() => setCurrentPage(p => p - 1)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                
                {pageNumbers.map(num => (
                  <button 
                    key={num}
                    className={`tims-nb-page-num ${currentPage === num ? "active" : ""}`}
                    onClick={() => setCurrentPage(num)}
                  >
                    {num}
                  </button>
                ))}

                <button 
                  className="tims-nb-page-nav" 
                  disabled={currentPage === totalPages} 
                  onClick={() => setCurrentPage(p => p + 1)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NoticeBoard;